/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

var FORM_CONTROL_COMPONENTS = ["TInput", "TTextarea", "TCascader", "TSelect", "TOption", "TSwitch", "TCheckbox", "TCheckboxGroup", "TRadio", "TRadioGroup", "TTreeSelect", "TDatePicker", "TTimePicker", "TUpload", "TTransfer", "TSlider"];

export { FORM_CONTROL_COMPONENTS };
//# sourceMappingURL=const.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/form/const.js
// module id = null
// module chunks = 